export const LinkToFacebookLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
  >
    <g
      id="Link_to_Facebook_Badge_-_Locked"
      data-name="Link to Facebook Badge - Locked"
      transform="translate(-2 -0.5)"
    >
      <circle
        id="Ellipse_44"
        data-name="Ellipse 44"
        cx="25"
        cy="25"
        r="25"
        transform="translate(3 1.5)"
        fill="none"
        stroke="#666"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <g
        id="_i_class_fab_fa-facebook-f_i_"
        data-name=" i class fab fa-facebook-f i "
        transform="translate(18.722 11.453)"
      >
        <g
          id="Group_2342"
          data-name="Group 2342"
          transform="translate(0 0)"
          style={{
            mixBlendMode: 'normal',
            isolation: 'isolate',
          }}
        >
          <g id="Group_2341" data-name="Group 2341">
            <path
              id="Path_2017"
              data-name="Path 2017"
              d="M44.354,51.559H37.341V38.319H32.889v-6.84h4.452V28.106a7.639,7.639,0,0,1,2.086-5.68,7.49,7.49,0,0,1,5.467-2.048,29.564,29.564,0,0,1,4.163.24l.674.1v6.154H46.166a2.1,2.1,0,0,0-1.534.41,2.236,2.236,0,0,0-.278,1.344v2.853H49.38l-.9,6.84H44.354ZM38.92,49.98h3.855V36.74h4.317l.486-3.682h-4.8V28.626a3.661,3.661,0,0,1,.635-2.343,3.368,3.368,0,0,1,2.756-.991h1.986V22.1a32.392,32.392,0,0,0-3.258-.139,5.894,5.894,0,0,0-4.359,1.594,6.054,6.054,0,0,0-1.615,4.555v4.952H34.468V36.74H38.92Z"
              transform="translate(-32.889 -20.378)"
              fill="#666"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const LinkToFacebookUnLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="52"
    height="56"
    viewBox="0 0 52 56"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Link_to_Facebook_Badge_-_Unlocked"
      data-name="Link to Facebook Badge - Unlocked"
      transform="translate(-2 3.5)"
    >
      <circle
        id="Ellipse_44"
        data-name="Ellipse 44"
        cx="25"
        cy="25"
        r="25"
        transform="translate(3 1.5)"
        stroke="#8d0034"
        strokeLinecap="round"
        strokeWidth="2"
        fill="url(#linear-gradient)"
      />
      <g
        id="_i_class_fab_fa-facebook-f_i_"
        data-name=" i class fab fa-facebook-f i "
        transform="translate(18.722 11.453)"
      >
        <g
          id="Group_2342"
          data-name="Group 2342"
          transform="translate(0 0)"
          style={{
            mixBlendMode: 'normal',
            isolation: 'isolate',
          }}
        >
          <g id="Group_2341" data-name="Group 2341">
            <path
              id="Path_2017"
              data-name="Path 2017"
              d="M44.354,51.559H37.341V38.319H32.889v-6.84h4.452V28.106a7.639,7.639,0,0,1,2.086-5.68,7.49,7.49,0,0,1,5.467-2.048,29.564,29.564,0,0,1,4.163.24l.674.1v6.154H46.166a2.1,2.1,0,0,0-1.534.41,2.236,2.236,0,0,0-.278,1.344v2.853H49.38l-.9,6.84H44.354ZM38.92,49.98h3.855V36.74h4.317l.486-3.682h-4.8V28.626a3.661,3.661,0,0,1,.635-2.343,3.368,3.368,0,0,1,2.756-.991h1.986V22.1a32.392,32.392,0,0,0-3.258-.139,5.894,5.894,0,0,0-4.359,1.594,6.054,6.054,0,0,0-1.615,4.555v4.952H34.468V36.74H38.92Z"
              transform="translate(-32.889 -20.378)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="Group_2806" data-name="Group 2806" transform="translate(36 -3.5)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
